import * as CarModels from './car/car';
import * as OrderModels from './order/order';
import * as DictionaryModels from './dictionary/dictionary';


export class RequestBase {

  public RequestSignature: number;

  public ContextCustomerId: number;

  public ContextGarageId: number;

  IsProcessing: boolean;

  constructor() {
    this.RequestSignature = Math.random();
    this.IsProcessing = false;

    const user = JSON.parse(localStorage.getItem('currentUser'));

    if (user) {
      this.ContextCustomerId = user.ContextCustomerId;
      this.ContextGarageId = user.ContextGarageId;
    }
  }

  public Begin() {

    const user = JSON.parse(localStorage.getItem('currentUser'));

    if (user) {
      this.ContextCustomerId = user.ContextCustomerId;
      this.ContextGarageId = user.ContextGarageId;
    }

    this.RequestSignature = Math.random();
    this.IsProcessing = true;
  }

  public End() {
    this.IsProcessing = false;
  }
}

export class SearchBaseModel extends RequestBase {
  public ItemsPerPage: number;
  public CurrentPage: number;
  public TotalItems: number;
  public PageCount: number;
  public IsPagination: boolean;

  constructor() {
    super();
    this.CurrentPage = 1;
    this.ItemsPerPage = 25;
    this.TotalItems = 0;
    this.PageCount = null;
    this.RequestSignature = Math.random();
    this.IsPagination = true;
  }
}

export class Request<T> extends RequestBase {

  public Item: T;

  constructor(item: T = null) {
    super();
    this.Item = item;
  }
}

export class ContextRequest<C, T> extends RequestBase {
  public Context: C;
  public Item: T;
}

export class RequestModel extends RequestBase {

  public Id: number;

  constructor(ModelId: number) {
    super();

    this.Id = ModelId;
  }
}

export class RequestStateModel extends RequestBase {

  public Id: number;
  public State: boolean;

  constructor(ModelId: number, ObjectState: boolean) {
    super();

    this.Id = ModelId;
    this.State = ObjectState;
  }
}


export class ResponseBase {
  Message: string;
  Success: boolean;
  RequestSignature: number;

  Initialize(Request: RequestBase) {
    this.RequestSignature = Request.RequestSignature;
  }
}

export class Response<T> extends ResponseBase {

  Item: T;
}

export class ResponseList<T> extends ResponseBase {

  Items: T[];

  TotalItems: number;
  CurrentPage: number;
  PageCount: number;
}

export class ListBaseModel extends ResponseBase {
  TotalItems: number;
  CurrentPage: number;
  PageCount: number;
}

export class ListBaseModelWithAdditonalReturnInformation extends ListBaseModel {
  IsCarExist: boolean;
  CarRegistrationNumber: string;
  CarCustomer: string;
}

export class RequestNewOrder<T> extends RequestBase {

  public AuthorizationText: string;

  public ReturnTakeAwayPerson: string;

  public Note: string;

  public Item: T;

  public Car: CarModels.CarCreateModel;

  public DestinationCar: CarModels.CarCreateModel;

  public OrderType: OrderModels.Types

  public SendSmsNotification: boolean;

  public Telephone: string;

  public RelocationDestinationGarageId: number;

  public IsRelocationWithReregistration: boolean;

  public IsRelocationToAddress: boolean;

  public RelocationAddress: DictionaryModels.AddressesDictionaryModel;

  public SourceAddress: DictionaryModels.AddressesDictionaryModel;

  public IsCurierSend: boolean;

  public IsCurierRegister: boolean;

  public IsCurierCartonBox: boolean;

  public RelocationCourierParcelValueId: number;

  public RelocationCourierParcelWeightId: number;

  public CourierId: number;

  public ShipmentNumber: string;

  public IsRelocationWithStorage: boolean;

  public IsNewCarValid(): boolean {
    return (this.Car.CustomerId &&
      this.Car.CarTypeId &&
      this.Car.RegistrationNumber &&
      this.Car.RegistrationNumber.length > 1 &&
      this.Car.Brand &&
      this.Car.Brand.length > 1);
  }

  public IsNewDestinationCarValid(): boolean {
    return (this.DestinationCar.CustomerId &&
      this.DestinationCar.CarTypeId &&
      this.DestinationCar.RegistrationNumber &&
      this.DestinationCar.RegistrationNumber.length > 1 &&
      this.DestinationCar.Brand &&
      this.DestinationCar.Brand.length > 1);
  }

  constructor() {
    super();
  }
}

//Do usunięcia - proszę używać RequestModel lub Request<T>
export class SaveState {

  constructor(ID: number, Success: boolean, Version: number = Math.random()) {
    this.ID = ID;
    this.Success = Success;
    this.Version = Version;
  }

  public ID: number;
  public Version: number;
  public Success: boolean;
}

export class FilterSetModel {
  tab: string;
  children: TabChildModel[];
  constructor() {
    this.tab = 'Filter tab';
    this.children = null;
  }
}

export class TabChildModel {
  disable?: boolean;
  filterName?: string;     // unique name of filter
  type: string;           // 'input' || 'select' || 'button' || 'inputNumber'=> step: number, min: number
  placeholder?: string;
  options?: boolean;      // have to be true for lists with badges
  items?: any[];          // dictionary
  bindLabel?: string;
  bindValue?: string;
  spinner?: boolean;
  step?: number;
  min?: number;
  info?: string;
  btntype?: string;

  constructor() {
    this.disable = false;
    this.placeholder = '';
    this.spinner = false;
    this.filterName = null;
    this.type = null;
    this.options = null;
    this.items = null;
    this.bindLabel = null;
    this.bindValue = null;
    this.btntype = 'export';
  }
}

//TODO Check if this class could be removed
export class ResponseModel {
  Code: number;
  Message: string;
  Success: boolean;
}

export class DateRange {
  StartDate: Date;
  EndDate: Date;
  constructor() {
    this.EndDate = null;
    this.StartDate = null;
  }
}

export class DictionaryBaseModel {
  value: number;
  label: string;
}

export class SelectedModel {

  public IsSelected: boolean = false;

  constructor() {
    this.IsSelected = false;
  }
}

export class BaseAllowedActions {
  public IsCancelAllowed: boolean;
  public IsCancelRequestAllowed: boolean;
  public IsSaveAllowed: boolean;
  public IsDoneAllowed: boolean;
  public IsAuthorizationUpdateAllowed: boolean;
  public IsRejectCancelRequestAllowed: boolean;
  public IsWithdrawalAllowed: boolean;  
}

export class BaseExecuteActions {
  public Cancel: boolean;
  public CancelRequest: boolean;
  public Done: boolean;
  public RejectCancelRequest: boolean;
  public Withdrawal: boolean;
}


export class DictionaryModel {
  public Id: number;
  public Label: string;
  public Data: any;
  public IsDefault: boolean;
}

export class ReportProcessing {
  public IsProcessing: boolean;
  public Name: string;

  public constructor(Name: string, IsProcessing: boolean) {
    this.Name = Name;
    this.IsProcessing = IsProcessing;
  }

  public static Start(Name: string): ReportProcessing {
    return new ReportProcessing(Name, true);
  }

  public static End(Name: string): ReportProcessing {
    return new ReportProcessing(Name, false);
  }
}
